import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Spinner from "../reusables/spinner";
import {
  create_category,
  create_product,
  fetch_products,
  get_categories,
  activate_product,
  delete_product,
  export_products,
} from "../../redux/actions/adminActions";
import { motion } from "framer-motion";
import { Carousel, Modal } from "react-bootstrap";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import InputField from "../reusables/input";
import Dropdown from "../reusables/dropdown";
import { periods, product_status } from "../../utils/options";
import ProductModal from "../modals/productModal";
import AddProduct from "./products/addProduct";
import Pagination from "../reusables/pagination";

function Products({
  products,
  getProducts,
  exportProducts,
  categories,
  getCategories,
  createCategory,
  accessToken,
  deleteProduct,
}) {
  const [loading, setLoading2] = useState(true);
  useEffect(() => {
    setLoading2(true);
    getProducts({ token: accessToken, success: () => setLoading2(false) });
    getCategories(accessToken);
  }, [getProducts, getCategories, accessToken]);

  const [ourProducts, setProducts] = useState(products);

  const [isLoading, setLoading] = useState(false);
  const [isLoadingExport, setLoadingExport] = useState(false);

  const [index, setIndex] = useState(0);

  const [addCategory, setAdd] = useState(false);

  const [categoryName, setName] = useState({ name: "" });

  const submitCategory = (e) => {
    e.preventDefault();
    createCategory(categoryName, accessToken);
  };

  const [editProduct, setEdit] = useState(null);

  const [activateModal, setActivate] = useState({ modal: false, id: [] });

  const [deactivateModal, setDeActivate] = useState({ modal: false, id: [] });

  const [deleteModal, setDelete] = useState({ modal: false, id: [] });

  const [selectedProducts, setSelected] = useState([]);
  const [exportType, setExportType] = useState("");

  const nextSlide = () => {
    setIndex(index + 1);
  };

  const [optionsActive, setOptions] = useState(null);

  const handleOptions = (id) => {
    if (optionsActive === null) {
      setOptions(id);
    } else {
      setOptions(null);
    }
  };

  const [hasFilter, setFilter] = useState(false);

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setLoading2(true);
    setTime(Item);
    let params = {
      filter: Item,
    };
    getProducts({
      token: accessToken,
      params: params,
      success: () => setLoading2(false),
    });
  };

  const [categorySelected, setCat] = useState("Category");

  const handleSelectCategory = (Item, id) => {
    // alert(Item);
    setCat(Item);
    setFilter(true);
    // const filtered = products.data.filter((i) => i.category?.name == Item);
    // setProducts(filtered);

    let params = {
      category: id,
    };
    getProducts({
      token: accessToken,
      params: params,
      success: () => setLoading2(false),
    });
  };

  const [selectedStatus, setStatus] = useState("Status");

  const handleFilter = (item) => {
    setLoading2(true);
    setStatus(item);
    setFilter(true);
    let params = {
      status: item,
    };
    getProducts({
      token: accessToken,
      params: params,
      success: () => setLoading2(false),
    });
  };

  const [search, setSearch] = useState("");

  const searchHandler = (e) => {
    if (search !== "") {
      let params = {
        search: search,
      };
      getProducts({
        token: accessToken,
        params: params,
        success: () => setLoading2(false),
      });
    } else {
      setFilter(false);
    }
  };

  const handleEdit = (item) => {
    setEdit(item);
    setIndex(1);
  };

  const handleSelect = (e) => {
    let updatedList = [...selectedProducts];
    if (e.target.checked) {
      updatedList = [...selectedProducts, Number(e.target.value)];
    } else {
      updatedList.splice(selectedProducts.indexOf(e.target.value), 1);
    }
    setSelected(updatedList);
  };

  useEffect(() => {
    setProducts(products);
  }, [products]);

  const addProduct = () => {
    setEdit(null);
    nextSlide();
  };

  const handleOptionSelect = (type) => {
    setExportType(type);
  };

  const handleExport = () => {
    //
    setLoadingExport(true);
    exportProducts(accessToken, selectedProducts, exportType, () =>
      setLoadingExport(false)
    );
  };

  const onPageChange = (page) => {
    setLoading2(true);
    let params = {
      page: page,
    };
    getProducts({
      token: accessToken,
      params: params,
      success: () => setLoading2(false),
    });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid">
        <Carousel activeIndex={index} indicators={false} controls={false}>
          <Carousel.Item>
            <div className="spaceBetween mobileBlock">
              <h2 className="sectionText--big textIsBold">Products</h2>

              <div className="alignOnly sectionText pt-2">
                <button className="btn__gray mx-2" onClick={() => setAdd(true)}>
                  Add Category
                </button>
                <button className="btn__filled mx-2" onClick={addProduct}>
                  Add New Products
                </button>
                <Dropdown value="Export">
                  <div className="isClickable hoverGreen">
                    <p
                      className="sectionText px-3 py-2 mb-0"
                      onClick={() => handleOptionSelect("csv")}
                    >
                      CSV
                    </p>
                  </div>
                  <div className="isClickable hoverGreen">
                    <p
                      className="sectionText px-3 py-2 mb-0"
                      onClick={() => handleOptionSelect("xlsx")}
                    >
                      EXCEL
                    </p>
                  </div>
                </Dropdown>
                <button
                  className={`btn__filled mx-2 ${
                    exportType == "" ? "btn__disabled" : ""
                  }`}
                  disabled={exportType != "" ? false : true}
                  onClick={handleExport}
                >
                  {!isLoadingExport ? "Export" : <Spinner />}
                </button>
              </div>
            </div>

            <div className="pt-4 suppliers">
              <div className="spaceBetween mobileBlock">
                <div className="searchHolder">
                  <InputField
                    value={search}
                    iconClick={searchHandler}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by product ID"
                    icon
                    iconClass="ri-search-line"
                  />
                </div>

                <div className="filters alignOnly pt-2">
                  <button
                    className={`btn__filled ${
                      !selectedProducts.length > 0 && "btn__disabled"
                    } hasRadius mx-1`}
                    disabled={!selectedProducts.length > 0}
                    onClick={() => {
                      setActivate({ modal: true, id: selectedProducts });
                    }}
                  >
                    Activate
                  </button>

                  <button
                    className={`btn__filled ${
                      !selectedProducts.length > 0 && "btn__disabled"
                    } hasRadius mx-1`}
                    disabled={!selectedProducts.length > 0}
                    onClick={() => {
                      setDeActivate({ modal: true, id: selectedProducts });
                    }}
                  >
                    Deactivate
                  </button>

                  <button
                    className={`btn__red ${
                      !selectedProducts.length > 0 && "btn__disabled"
                    } hasRadius mx-1`}
                    disabled={!selectedProducts.length > 0}
                    onClick={() => {
                      setDelete({ modal: true, id: selectedProducts });
                    }}
                  >
                    Delete
                  </button>

                  <Dropdown value={categorySelected} className="mx-1">
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => {
                        setCat("All Categories");
                        setFilter(false);
                        handleSelectCategory("All Categories", 0);
                      }}
                    >
                      <p className="sectionText px-3 py-2 mb-0">
                        All Categories
                      </p>
                    </div>
                    {categories?.map((item) => (
                      <div
                        className="isClickable hoverGreen"
                        onClick={() => handleSelectCategory(item.name, item.id)}
                      >
                        <p className="sectionText px-3 py-2 mb-0">
                          {item.name}
                        </p>
                      </div>
                    ))}
                  </Dropdown>

                  <Dropdown value={selectedTime} className="mx-1">
                    {periods?.map((item) => (
                      <div
                        className="isClickable hoverGreen"
                        onClick={() => handleSelectTime(item)}
                      >
                        <p className="sectionText px-3 py-2 mb-0">{item}</p>
                      </div>
                    ))}
                  </Dropdown>

                  <Dropdown value={selectedStatus} className="mx-1">
                    {product_status?.map((item) => (
                      <div
                        className="isClickable hoverGreen"
                        onClick={() => handleFilter(item)}
                      >
                        <p className="sectionText px-3 py-2 mb-0">{item}</p>
                      </div>
                    ))}
                  </Dropdown>
                </div>
              </div>

              <div className="fullHeight scrollable--mobile pt-5">
                {/* {
                hasFilter ? (
                  ourProducts?.length > 0 ? (
                    <table className="table table__custom">
                      <thead className="sectionText--small textIsGray table__head pb-2">
                        <tr className="">
                          <th className="">Product Id</th>
                          <th className="vAlign">Product Name</th>
                          <th className="vAlign">Category</th>
                          <th className="vAlign">Unit Cost</th>
                          <th className="vAlign">Unit Weight</th>
                          <th className="vAlign">Date Added</th>
                          <th className="vAlign">Status</th>
                          <th className="vAlign">Action</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {ourProducts?.map((item) => (
                          <tr className="hasRadius">
                            <td className="alignOnly pt-3">
                              <input
                                type="checkbox"
                                className="isClickable"
                                name=""
                                id=""
                                value={item.id}
                                onChange={handleSelect}
                              />

                              <p className="mb-0  sectionText mx-2">
                                {item.product_id || "-"}
                              </p>
                            </td>

                            <td className="pt-3 vAlign">
                              <p className="mb-0  sectionText">
                                {item.product_name}
                              </p>
                            </td>

                            <td className="pt-3 vAlign">
                              <p className="mb-0  sectionText">
                                {item.category?.name}
                              </p>
                            </td>

                            <td className="vAlign pt-3">
                              <p className="mb-0 sectionText">
                                ₦ {item.product_price}
                              </p>
                            </td>

                            <td className="vAlign pt-3 address">
                              <p className="mb-0 sectionText">
                                {item.unit_weight || "-"}
                              </p>
                            </td>

                            <td className="vAlign pt-3">
                              <p className="mb-0  sectionText">{item.date}</p>
                            </td>

                            <td className="center">
                              <div
                                className={`tag ${
                                  item?.status === "active" ? "done" : "gray"
                                }`}
                              >
                                {item.status}
                              </div>
                            </td>

                            <td className="vAlign pt-3">
                              <i
                                class="ri-more-line isClickable"
                                onClick={() => handleOptions(item.id)}
                              ></i>

                              {optionsActive === item?.id && (
                                <div className="options">
                                  <div className="caret"></div>
                                  <div className="p-2 textIsBold lAlign sectionText--small">
                                    <div
                                      className="py-2"
                                      onClick={
                                        item.status === "active"
                                          ? () =>
                                              setDeActivate({
                                                ...deactivateModal,
                                                modal: true,
                                                id: [item.id],
                                              })
                                          : () =>
                                              setActivate({
                                                ...activateModal,
                                                modal: true,
                                                id: [item.id],
                                              })
                                      }
                                    >
                                      {item.status === "active"
                                        ? "Deactivate"
                                        : "Activate"}
                                    </div>
                                    <div
                                      className="py-2"
                                      onClick={() => handleEdit(item)}
                                    >
                                      Edit
                                    </div>
                                    <div className="py-2 isRed">Delete</div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="w-100 center sectionHeight--mid pt-4">
                      <h2 className="sectionHead--small textIsBold textIsGreen">
                        No products found --
                      </h2>
                    </div>
                  )
                ) :  */}

                {!loading ? (
                  ourProducts?.data?.length > 0 ? (
                    <table className="table table__custom">
                      <thead className="sectionText--small textIsGray table__head pb-2">
                        <tr className="">
                          <th className="">Product Id</th>
                          <th className="vAlign">Product Name</th>
                          <th className="vAlign">Category</th>
                          <th className="vAlign">Unit Cost</th>
                          <th className="vAlign">Unit Weight</th>
                          <th className="vAlign">Date Added</th>
                          <th className="vAlign">Status</th>
                          <th className="vAlign">Action</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {ourProducts?.data?.map((item) => (
                          <tr className="hasRadius">
                            <td className="alignOnly pt-3">
                              <input
                                type="checkbox"
                                className="isClickable"
                                name=""
                                id=""
                                value={item.id}
                                onChange={handleSelect}
                              />

                              <p className="mb-0  sectionText mx-2">
                                {item.product_id || "-"}
                              </p>
                            </td>

                            <td className="pt-3 vAlign">
                              <p className="mb-0  sectionText">
                                {item.product_name}
                              </p>
                            </td>

                            <td className="pt-3 vAlign">
                              <p className="mb-0  sectionText">
                                {item.category?.name}
                              </p>
                            </td>

                            <td className="vAlign pt-3">
                              <p className="mb-0 sectionText">
                                ₦ {item.product_price}
                              </p>
                            </td>

                            <td className="vAlign pt-3 address">
                              <p className="mb-0 sectionText">
                                {item.unit_weight || "-"}
                              </p>
                            </td>

                            <td className="vAlign pt-3">
                              <p className="mb-0  sectionText">{item.date}</p>
                            </td>

                            <td className="center">
                              <div
                                className={`tag ${
                                  item?.status === "active" ? "done" : "gray"
                                }`}
                              >
                                {item.status}
                              </div>
                            </td>

                            <td className="vAlign pt-3">
                              <i
                                class="ri-more-line isClickable"
                                onClick={() => handleOptions(item.id)}
                              ></i>

                              {optionsActive === item?.id && (
                                <div className="options">
                                  <div className="caret"></div>
                                  <div className="p-2 textIsBold lAlign sectionText--small">
                                    <div
                                      className="py-2"
                                      onClick={
                                        item.status === "active"
                                          ? () =>
                                              setDeActivate({
                                                ...deactivateModal,
                                                modal: true,
                                                id: [item.id],
                                              })
                                          : () =>
                                              setActivate({
                                                ...activateModal,
                                                modal: true,
                                                id: [item.id],
                                              })
                                      }
                                    >
                                      {item.status === "active"
                                        ? "Deactivate"
                                        : "Activate"}
                                    </div>
                                    <div
                                      className="py-2"
                                      onClick={() => handleEdit(item)}
                                    >
                                      Edit
                                    </div>
                                    <div
                                      className="isRed py-2"
                                      onClick={() =>
                                        setDelete({
                                          ...deleteModal,
                                          modal: true,
                                          id: [item.id],
                                        })
                                      }
                                    >
                                      Delete
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="w-100 center sectionHeight--mid pt-4">
                      <h2 className="sectionHead--small textIsBold textIsGreen">
                        No products found
                      </h2>
                    </div>
                  )
                ) : (
                  <Spinner big />
                )}
                <div className="d-flex justify-content-end">
                  <Pagination
                    onChange={onPageChange}
                    page={products?.current_page}
                    total={products?.total}
                    per_page={products?.per_page}
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <AddProduct
              prev={() => setIndex(index - 1)}
              prevData={editProduct}
              active={editProduct?.status === "active"}
            />
          </Carousel.Item>
        </Carousel>
      </div>

      <ProductModal
        id={activateModal.id}
        show={activateModal.modal}
        handleClose={() =>
          setActivate({
            ...activateModal,
            modal: false,
          })
        }
      />

      <ProductModal
        deactivate
        id={deactivateModal.id}
        show={deactivateModal.modal}
        handleClose={() =>
          setDeActivate({
            ...deactivateModal,
            modal: false,
          })
        }
      />

      <Modal
        show={deleteModal.modal}
        onHide={() =>
          setDelete({
            ...deleteModal,
            modal: false,
          })
        }
        centered
      >
        <div className="sectionHeight--mid alignOnly container p-3">
          <div className="w-100 vAlign p-4">
            <h2 className="sectionText--mid">
              Are you sure you want to delete{" "}
              {deleteModal.id.length > 1 ? "these" : "this"} product
              {deleteModal.id.length > 1 && "s"}?
            </h2>

            <div className="mt-3">
              {isLoading ? (
                <div className="center">
                  <Spinner />
                </div>
              ) : (
                <>
                  {" "}
                  <button
                    className="btn__filled mx-2 hasRadius"
                    onClick={() =>
                      setDelete({
                        ...deleteModal,
                        modal: false,
                      })
                    }
                  >
                    No, Cancel
                  </button>{" "}
                  <button
                    className="btn__transparent"
                    onClick={() => {
                      deleteProduct(deleteModal.id, accessToken, () => {
                        setDelete({
                          ...deleteModal,
                          modal: false,
                        });
                        setLoading(false);
                      });
                      setLoading(true);
                    }}
                  >
                    {" "}
                    Yes, Delete{" "}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <Modal show={addCategory} onHide={() => setAdd(false)} centered>
        <div className="sectionHeight--mid alignOnly container p-3">
          <div
            className="icon--tiny isClickable closeModal"
            onClick={() => setAdd(false)}
          >
            <i class="ri-close-line sectionText--small"></i>
          </div>
          <div className="w-100 p-4">
            <form className="spaceBetween" onSubmit={submitCategory}>
              <div className="">
                <InputField
                  label="Add New Category"
                  name="name"
                  value={categoryName.name}
                  onChange={(e) =>
                    setName({
                      ...categoryName,
                      name: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mt-3">
                <button className="btn__filled hasRadius btn__long mb-0">
                  Save
                </button>
              </div>
            </form>

            <div className="mt-4">
              <p className="sectionText--small textIsGray mb-2">
                Existing Category
              </p>
              {categories?.map((item) => (
                <p className="sectionText mb-2">{item?.name}</p>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  products: state.admin.products,
  categories: state.admin.categories,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (token, filter, success) =>
    dispatch(fetch_products(token, filter, success)),
  exportProducts: (token, data, type, success) =>
    dispatch(export_products(token, data, type, success)),
  activateProduct: (data, token) => dispatch(activate_product(data, token)),
  getCategories: (token) => dispatch(get_categories(token)),
  createCategory: (data, token) => dispatch(create_category(data, token)),
  createProduct: (data, newProduct, token) =>
    dispatch(create_product(data, newProduct, token)),
  deleteProduct: (id, token, success) =>
    dispatch(delete_product(id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
